export default __webpack_public_path__ + "static/video-placeholder-4a0ce74b798b166638dd366036f03394.jpg";